import { Container } from "@mui/material";
import { DataStoreBreadcrumbs } from "~/components/DataStoreBreadcrumbs";
import { LqsPage } from "~/lqs/layout";
import { WorkflowEditForm } from "./components/WorkflowEditForm";

export function EditWorkflowPage() {
  return (
    <LqsPage title="Edit Workflow">
      <Container fixed>
        <DataStoreBreadcrumbs />
        <WorkflowEditForm />
      </Container>
    </LqsPage>
  );
}
